import { Exclude, Expose, Type } from 'class-transformer';
import { AddressModel } from '@core/address';
import { Default } from '@core/util';
import { BaseModel } from '@core/data-access';

@Exclude()
export class PersonnelAddressModel extends BaseModel {
  @Expose() @Default(() => AddressModel.createEmpty()) @Type(() => AddressModel) residential!: AddressModel;
  @Expose() @Default(() => AddressModel.createEmpty()) @Type(() => AddressModel) mailing!: AddressModel;
  @Expose() @Default(false) differentResidential!: boolean;
}
